import React, { useEffect, useState } from 'react'
import { Accordion, Button, Form, Card, Row, Col, Container, Badge, Modal } from 'react-bootstrap'
import upload from '../../assets/images/Paper Upload.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Loader from '../../components/loader/loader';
import {
  createManufacturer,
  getManufacturerDetails,
  statusUpdateTiming,
  updateManufacturer,
  verifyVendor,
} from '../../api/context/manufacturer'
import toast from 'react-hot-toast'
import * as yup from 'yup'
import { useFormik } from 'formik'
import imageToBase64 from 'image-to-base64/browser'
import { uploadBulkProducts } from '../../api/context/products'
import { Switch } from '@mui/material'
import { MdOutlineUploadFile } from 'react-icons/md'
import sampleFile from '../../assets/files/sample-sheet.xlsx'
import { useRecoilState } from 'recoil'
import { updateDetailsState } from '../../atoms/updateDetails'
import { BsDownload, BsEye, BsEyeSlash, BsInfoCircle, BsX } from 'react-icons/bs'
import { IoMdArrowBack } from 'react-icons/io'
import GoogleMap from 'google-map-react'
import AsyncSelect from 'react-select/async';
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from 'react-google-places-autocomplete'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { GOOGLE_MAP_API_KEY } from '../../utils/config'
import { FiUploadCloud } from 'react-icons/fi'
import { getBrandListing } from '../../api/context/brand'
import { Verified } from '@mui/icons-material'
import ErrorState from '../../components/Error/errorState';


const CreateManufacturer = () => {
  const navigate = useNavigate()

  const { id } = useParams()

  const user = JSON.parse(localStorage.getItem('user'))

  console.log(user, 'user is here')

  const [dataLoading, setDataLoading] = useState(false)
  const [dataError, setDataError] = useState(false)


  const [page, setPage] = useState(1);
  const [brands, setBrands] = useState([]);
  const [brandError, setBrandError] = useState(false);

  const [selectedBrands, setSelectedBrands] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  let typingTimer;

  const [verifyLoading, setVerifyLoading] = useState(false)
  const [isVerified, setIsVerified] = useState(false)


  const [selectedFiles, setSelectedFiles] = useState([])
  const [loading, setLoading] = useState(false)
  const [update, setUpdate] = useState(false)
  const [store, setStore] = useState([])
  const [bulkLoading, setBulkLoading] = useState(false)
  const [bulkModal, setBulkModal] = useState(false)
  const [refresh, setRefresh] = useRecoilState(updateDetailsState)
  const [showaccnumber, setShowAccnumber] = useState({
    accountNumber: false,
    reaccountNumber: false,
  })
  const [script, setScript] = useState(false)
  const [value, setValue] = useState(null)
  const [mapCenter, setMapCenter] = useState({ lat: 28.461272, lng: 77.026825 })

  const toggleaccountNumberVisibility = (fieldName) => {
    setShowAccnumber((prev) => ({ ...prev, [fieldName]: !prev[fieldName] }))
  }

  const [previewImage, setPreviewImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const openPreview = (img) => {
    setPreviewImage(img);
    setShowPreview(true);
  };

  const closePreview = () => {
    setPreviewImage(null);
    setShowPreview(false);
  };





  const handleVerifyVendor = async () => {
    if (!id) return

    // Validate all required fields before verification
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      toast.error('Some required fields are missing or invalid');

      // Mark all fields as touched to show errors
      const allTouched = {};
      Object.keys(formik.initialValues).forEach(key => {
        allTouched[key] = true;
      });
      formik.setTouched(allTouched);

      return;
    }

    setVerifyLoading(true)
    try {
      verifyVendor({ vendorId: id })((response) => {
        if (response?.data?.statusCode === 200) {
          setVerifyLoading(false)
          setIsVerified(true)
          setRefresh(!refresh)
          toast.success('Vendor verified successfully')

          // Update local state if needed
          setStore(prev => ({ ...prev, isVerified: true }))
        } else {
          setVerifyLoading(false)
          toast.error('Vendor verification failed')
        }
      })
    } catch (error) {
      setVerifyLoading(false)
      toast.error('Vendor verification failed. Please try again.')
    }
  }

  const handleFileChange = (event) => {
    const files = event.target.files
    setSelectedFiles(files)
  }

  const cancelStore = () => {
    if (user?.userType === 'Vendor') {
      navigate('/my-profile')
    } else {
      navigate('/vendors')
    }
  }

  const validationSchema = yup.object().shape({
    storeName: yup
      .string()
      .required('Store name is required')
      .min(2, 'Store name must be at least 2 characters')
      .max(100, 'Store name cannot exceed 100 characters'),

    // img_view: yup.string().required('Store image is required'),
    // pan_copy_view: yup.string().required('PAN copy image is required'),
    // gst_copy_view: yup.string().required('GST copy image is required'),
    // cancelled_cheque_view: yup.string().required('Cancelled cheque image is required'),

    ownerName: yup
      .string()
      .required('Owner name is required')
      .min(2, 'Owner name must be at least 2 characters')
      .max(50, 'Owner name cannot exceed 50 characters'),

    phoneNumber: yup
      .string()
      .matches(/^[1-9][0-9]{9}$/, 'Mobile number must be 10 digits, cannot start with 0, and contain only numbers')
      .required('Phone number is required'),

    email: yup
      .string()
      .email('Enter a valid email address')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Enter a valid email address'
      )
      .required('Email is required')
      .max(100, 'Email cannot exceed 100 characters'),

    commission: yup
      .number()
      .typeError('Commission must be a number')
      .min(0, 'Commission cannot be negative')
      .max(100, 'Commission cannot exceed 100%')
      .required('Commission is required'),

    address: yup
      .string()
      .required('Address is required')
      .min(5, 'Address must be at least 5 characters')
      .max(200, 'Address cannot exceed 200 characters'),

    state: yup
      .string()
      .matches(/^[a-zA-Z\s]+$/, 'State can only contain letters and spaces')
      .required('State is required')
      .min(2, 'State must be at least 2 characters')
      .max(50, 'State cannot exceed 50 characters'),

    city: yup
      .string()
      .matches(/^[a-zA-Z\s]+$/, 'City can only contain letters and spaces')
      .required('City is required')
      .min(2, 'City must be at least 2 characters')
      .max(50, 'City cannot exceed 50 characters'),

    landmark: yup
      .string()
      .required('Landmark is required')
      .min(2, 'Landmark must be at least 2 characters')
      .max(100, 'Landmark cannot exceed 100 characters'),

    postalcode: yup
      .string()
      .matches(/^[1-9][0-9]{5}$/, 'Enter a valid 6-digit PinCode')
      .required('PinCode is required'),

    businessName: yup
      .string()
      .matches(/^[a-zA-Z0-9\s\-&.,]+$/, 'Business name can only contain letters, numbers, spaces, and basic punctuation')
      // .required('Business name is required')
      .min(2, 'Business name must be at least 2 characters')
      .max(100, 'Business name cannot exceed 100 characters'),

    bankName: yup
      .string()
      .matches(/^[a-zA-Z0-9\s\-&.,]+$/, 'Bank name can only contain letters, numbers, spaces, and basic punctuation')
      .required('Bank name is required')
      .min(2, 'Bank name must be at least 2 characters')
      .max(100, 'Bank name cannot exceed 100 characters'),

    accountType: yup
      .string()
      .matches(/^[a-zA-Z\s]+$/, 'Account type can only contain letters and spaces')
      .required('Account type is required'),

    accountHolderName: yup
      .string()
      .matches(/^[a-zA-Z\s.'-]+$/, 'Account holder name can only contain letters, spaces, apostrophes, and hyphens')
      .required('Account holder name is required')
      .min(2, 'Account holder name must be at least 2 characters')
      .max(50, 'Account holder name cannot exceed 50 characters'),

    accountNumber: yup
      .string()
      .matches(/^[0-9]+$/, 'Account number must contain only numbers')
      .required('Account number is required')
      .min(9, 'Account number must be at least 9 digits')
      .max(18, 'Account number cannot exceed 18 digits'),


    reaccountNumber: yup
      .string()
      .oneOf([yup.ref('accountNumber'), null], 'Account numbers must match')
      .required('Re-entered Account number is required'),

    ifscCode: yup
      .string()
      .required('IFSC code is required'),

    gst: yup
      .string()
      .length(15, 'GST must be 15 characters')
      .required('GST is required'),

    pan: yup
      .string()
      // .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter a valid PAN number (e.g., ABCDE1234F)')
      .length(10, 'PAN must be 10 characters')
      .required('PAN is required'),
  });

  const formik = useFormik({
    initialValues: {
      storeName: '',
      image: '',
      pan_copy_image: '',
      gst_copy_image: '',
      cancelled_cheque_image: '',
      img_view: '',
      pan_copy_view: '',
      gst_copy_view: '',
      cancelled_cheque_view: '',
      businessName: '',
      ownerName: '',
      phoneNumber: '',
      email: '',
      address: '',
      state: '',
      city: '',
      postalcode: '',
      landmark: '',
      description: '',
      pan: '',
      gst: '',
      gstApplicable: false,
      commission: '',
      bankName: '',
      accountType: '',
      accountHolderName: '',
      accountNumber: '',
      reaccountNumber: '',
      ifscCode: '',
      latitude: '',
      longitude: '',
      place_id: '',
      brandIds: [],
      selectedBrands: [],
      storeTimings: [
        {
          day: 'Monday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Tuesday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Wednesday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Thursday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Friday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Saturday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: true,
        },
        {
          day: 'Sunday',
          openingTime: '10:00',
          closingTime: '22:00',
          isActive: false,
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      if (selectedBrands.length === 0) {
        setBrandError(true);
        return;
      } else {
        setBrandError(false);
      }
      setLoading(true)


      const brandIds = selectedBrands.map(brand => brand.value);

      // delete values.reaccountNumber;
      const { reaccountNumber, ...rest } = values
      const data = {
        ...rest,
        brandIds,
      }

      try {
        if (id) {
          updateManufacturer(data)((response) => {
            if (response?.data?.statusCode == 200) {
              if (values.image == '') {
                delete values.image
              }
              if (values.pan_copy_image == '') {
                delete values.pan_copy_image
              }
              if (values.gst_copy_image == '') {
                delete values.gst_copy_image
              }
              if (values.cancelled_cheque_image == '') {
                delete values.cancelled_cheque_image
              }
              delete values.img_view;
              delete values.pan_copy_view;
              delete values.gst_copy_view;
              delete values.cancelled_cheque_view;
              delete values.selectedBrands;
              setLoading(false)
              setRefresh(!refresh)
              resetForm()
              toast.success('Store Updated Successfully')
              if (user?.userType === 'Vendor') {
                navigate('/my-profile')
              } else {
                navigate('/vendors')
              }
            } else {
              setLoading(false)
              toast.error(response?.data?.message)
            }
          })
        } else {
          createManufacturer(data)((response) => {
            if (response?.data?.statusCode == 200) {
              setLoading(false)
              if (bulkFormik?.values?.file) {
                handlebulkSubmit(
                  bulkFormik?.values?.file,
                  response?.data?.data?.id
                )
              } else {
                toast.success('Store Created Successfully')
                navigate('/vendors')
              }
              // handlebulkSubmit(bulkFormik.values.file, response?.data?.data?.id)
              // bulkFormik.submitForm();
            } else {
              setLoading(false)
              formik.setErrors({
                email: response?.data?.message,
              })
              toast.error(response?.data?.message)
            }
          })
        }
      } catch (error) {
        console.error(error)

        setLoading(false)
      }
    },
  })


  const bulkFormik = useFormik({
    initialValues: {
      file: '',
      filename: '',
    },
    validationSchema: yup.object().shape({
      file: yup.string('').required('Required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true)
      setBulkLoading(true)
      try {
        console.log(values)
        let formData = new FormData()
        formData.append('file', values.file)
        uploadBulkProducts(formData)((response) => {
          if (response && response?.data?.statusCode == 200) {
            setLoading(false)
            setBulkLoading(false)
            setBulkModal(false)
            resetForm()
            toast.success('Store Created Successfully')
            navigate('/vendors')
          } else {
            setLoading(false)
            setBulkLoading(false)
            toast.error(response?.data?.message)
          }
        })
      } catch (error) {
        console.error(error)
        toast.error('something went wrong!, please try again', 'error')
        setLoading(false)
        setBulkLoading(false)
      }
    },
  })

  const handlebulkSubmit = (file, man_id) => {
    let formData = new FormData()
    formData.append('manufacturerId', man_id)
    formData.append('file', file)
    uploadBulkProducts(formData)((response) => {
      if (response && response?.data?.statusCode == 200) {
        setLoading(false)
        setBulkLoading(false)
        setBulkModal(false)
        toast.success('Store Created Successfully')
        navigate('/vendors')
      } else {
        setLoading(false)
        setBulkLoading(false)
        toast.error(response?.data?.message)
      }
    })
  }

  const handleImageChange = async (e) => {
    const file = e?.target?.files[0];
    const inputId = e?.target?.id;

    if (!file) return;

    try {
      const response = await imageToBase64(URL.createObjectURL(file));
      const base64Image = 'data:image/jpeg;base64,' + response;

      const fieldMap = {
        storeImage: { imageField: 'image', previewField: 'img_view' },
        panCopy: { imageField: 'pan_copy_image', previewField: 'pan_copy_view' },
        gstCopy: { imageField: 'gst_copy_image', previewField: 'gst_copy_view' },
        cancelledChequeCopy: { imageField: 'cancelled_cheque_image', previewField: 'cancelled_cheque_view' }
      };

      const fieldConfig = fieldMap[inputId];

      if (fieldConfig) {
        formik.setValues({
          ...formik.values,
          [fieldConfig.imageField]: base64Image,
          [fieldConfig.previewField]: base64Image,
        });

        // Clear any previous validation errors for this field
        formik.setFieldTouched(fieldConfig.imageField, true, false);
      }
    } catch (error) {
      console.error('Error processing image:', error);
      toast.error('Failed to process image. Please try again.');
    }
  };


  const statusActive = (timeid, active, index) => {
    console.log(timeid, active)
    if (id) {
      statusUpdateTiming({ timingId: timeid, isActive: !active })(
        (response) => {
          if (response?.status == 200) {
            setUpdate(!update)
          } else {
          }
        }
      )
    } else {
      const updatedStoreTimings = formik.values.storeTimings
      updatedStoreTimings[index].isActive = !active
      formik.setValues({
        ...formik.values,
        storeTimings: updatedStoreTimings,
      })
    }
  }

  const formatTime = (timeString) => {
    const time = new Date(`1970-01-01T${timeString}`)

    const hours = time.getHours().toString().padStart(2, '0')
    const minutes = time.getMinutes().toString().padStart(2, '0')

    return `${hours}:${minutes}`
  }

  const getManufacturer = async () => {
    setDataLoading(true)
    setDataError(false)

    getManufacturerDetails(id)(async (response) => {
      if (response?.data?.statusCode == 200) {
        const manufacturer = response?.data?.data[0]
        // Prefer VendorBrands if present, fallback to Brands
        let initialSelectedBrands = [];
        if (manufacturer.VendorBrands && manufacturer.VendorBrands.length > 0) {
          initialSelectedBrands = manufacturer.VendorBrands
            .map(vb => vb.Brand ? { value: vb.Brand.id, label: vb.Brand.name } : null)
            .filter(Boolean);
        } else if (manufacturer.Brands && manufacturer.Brands.length > 0) {
          initialSelectedBrands = manufacturer.Brands.map(brand => ({
            value: brand.id,
            label: brand.name,
          }));
        }

        setSelectedBrands(initialSelectedBrands);


        formik.setValues((prevState) => ({
          ...prevState,
          id: id,
          place_id: manufacturer?.place_id || '',
          storeName: manufacturer?.storeName ? manufacturer?.storeName : '',
          ownerName: manufacturer?.ownerName ? manufacturer?.ownerName : '',
          // image: manufacturer?.image ? manufacturer?.image : '',
          img_view: manufacturer?.image ? manufacturer?.image : '',
          businessName: manufacturer?.VendorBankDetails[0]?.businessNameAsPerGST ? manufacturer?.VendorBankDetails[0]?.businessNameAsPerGST : '',
          pan_copy_view: manufacturer?.VendorBankDetails[0]?.panCopy ? manufacturer?.VendorBankDetails[0]?.panCopy : '',
          gst_copy_view: manufacturer?.VendorBankDetails[0]?.gstCopy ? manufacturer?.VendorBankDetails[0]?.gstCopy : '',
          cancelled_cheque_view: manufacturer?.VendorBankDetails[0]?.cancelledChequeCopy ? manufacturer?.VendorBankDetails[0]?.cancelledChequeCopy : '',

          phoneNumber: manufacturer?.phoneNumber
            ? manufacturer?.phoneNumber
            : '',
          gstApplicable: manufacturer?.gstApplicable
            ? manufacturer?.gstApplicable
            : false,
          pan: manufacturer?.VendorBankDetails[0]?.pan
            ? manufacturer?.VendorBankDetails[0]?.pan
            : '',
          gst: manufacturer?.VendorBankDetails[0]?.gst
            ? manufacturer?.VendorBankDetails[0]?.gst
            : '',
          commission: manufacturer?.commission ?? '',

          email: manufacturer?.email ? manufacturer?.email : '',
          address: manufacturer?.address ? manufacturer?.address : '',
          state: manufacturer?.state ? manufacturer?.state : '',
          city: manufacturer?.city ? manufacturer?.city : '',
          description: manufacturer?.description
            ? manufacturer?.description
            : '',
          landmark: manufacturer?.landmark ? manufacturer?.landmark : '',
          postalcode: manufacturer?.postalcode ? manufacturer?.postalcode : '',
          latitude: manufacturer?.latitude ? manufacturer?.latitude : '',
          longitude: manufacturer?.longitude ? manufacturer?.longitude : '',
          bankName: manufacturer?.VendorBankDetails[0]?.bankName
            ? manufacturer?.VendorBankDetails[0]?.bankName
            : '',
          accountType: manufacturer?.VendorBankDetails[0]?.accountType
            ? manufacturer?.VendorBankDetails[0]?.accountType
            : '',
          accountHolderName: manufacturer?.VendorBankDetails[0]
            ?.accountHolderName
            ? manufacturer?.VendorBankDetails[0]?.accountHolderName
            : '',
          accountNumber: manufacturer?.VendorBankDetails[0]?.accountNumber
            ? manufacturer?.VendorBankDetails[0]?.accountNumber
            : '',
          reaccountNumber: manufacturer?.VendorBankDetails[0]?.accountNumber
            ? manufacturer?.VendorBankDetails[0]?.accountNumber
            : '',
          ifscCode: manufacturer?.VendorBankDetails[0]?.ifscCode
            ? manufacturer?.VendorBankDetails[0]?.ifscCode
            : '',
          storeTimings: manufacturer?.StoreTimings
            ? manufacturer.StoreTimings
            : prevState.storeTimings,

          selectedBrands: initialSelectedBrands,
          brandIds: initialSelectedBrands.map(brand => brand.value),


        }))


        // Set the GooglePlacesAutocomplete value for edit mode
        // In getManufacturer function, update the value setting:
        setValue(
          manufacturer?.place_id && manufacturer?.address
            ? {
              label: manufacturer.address,
              value: {
                place_id: manufacturer.place_id,
                description: manufacturer.address
              }
            }
            : null
        )

        setIsVerified(manufacturer?.isVerified || false);

        // Set the map center with latitude and longitude
        setMapCenter({
          lat: manufacturer?.latitude ?? 0,
          lng: manufacturer?.longitude ?? 0,
        })
        setStore(manufacturer)
        setDataLoading(false)

      } else {
        setDataError(true)
        setStore([])
        setDataLoading(false)

      }
    })

  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    const trimmedValue = value.replace(/^\s+/, '')
    formik.setFieldValue(name, trimmedValue)
  }

  useEffect(() => {
    if (id) {
      // setLoading(true)
      getManufacturer()
    }
  }, [update, id])

  useEffect(() => {
    const existingScript = document.getElementById('googleMaps')
    if (!existingScript) {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`
      script.id = 'googleMaps'
      document.body.appendChild(script)
      script.onload = () => setScript(true)
    } else {
      setScript(true)
    }
  }, [GOOGLE_MAP_API_KEY])

  const changeValue = async (value) => {
    setValue(value)
    try {
      const results = await geocodeByPlaceId(value?.value?.place_id)
      const location = results[0]
      const { lat, lng } = await getLatLng(location)

      setMapCenter({ lat, lng })
      formik.setFieldValue('latitude', lat)
      formik.setFieldValue('longitude', lng)
      formik.setFieldValue('place_id', value?.value?.place_id)

      // Extract address components
      const addressComponents = location?.address_components || []
      const address = location?.formatted_address || ''

      const getComponent = (type) =>
        addressComponents.find((component) => component.types.includes(type))
          ?.long_name || ''

      const state = getComponent('administrative_area_level_1')
      const city =
        getComponent('locality') || getComponent('administrative_area_level_2')
      const postalcode = getComponent('postal_code')

      formik.setFieldValue('address', address)
      formik.setFieldValue('state', state)
      formik.setFieldValue('city', city)
      formik.setFieldValue('postalcode', postalcode)
    } catch (error) {
      console.error('Error fetching location coordinates:', error)
    }
  }

  const handleMapClick = ({ lat, long }) => {
    console.log(lat, long)

    mapCenter({ lat, long })
    formik.setFieldValue('latitude', lat)
    formik.setFieldValue('longitude', long)
  }

  useEffect(() => {
    const inputs = document.getElementsByTagName('input')
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('autocomplete', 'one-time-code')
    }
    fetchBrands('', 1);
  }, [])

  const downloadImage = (imageSrc, filename = 'document') => {
    if (!imageSrc) return;

    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        getBrandListing({ page: currentPage, pageSize: limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            // Filter out already selected brands
            const filteredResults = results.filter(
              brand => !selectedBrands.some(selected => selected.value === brand.value)
            );

            if (currentPage === 1) {
              setBrands(filteredResults);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...filteredResults]);
            }

            setHasMore(results.length > 0);
            resolve(filteredResults);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsBrands = (inputValue) => {
    return fetchBrands(inputValue, 1);
  };

  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = page + 1;
      fetchBrands('', nextPage).then(() => {
        setPage(nextPage);
      });
    }
  };

  const onBrandChange = (selectedOptions) => {
    setSelectedBrands(selectedOptions);
    setBrandError(false); // Clear error on change
    formik.setValues({
      ...formik.values,
      selectedBrands: selectedOptions,
      brandIds: selectedOptions.map(brand => brand.value),
    });
  };


  const removeBrand = (brandToRemove) => {
    const updatedBrands = selectedBrands.filter(brand => brand.value !== brandToRemove.value);
    setSelectedBrands(updatedBrands);

    // Update formik values
    formik.setValues({
      ...formik.values,
      selectedBrands: updatedBrands,
      brandIds: updatedBrands.map(brand => brand.value),
    });
  };


  return (
    <Container fluid className="py-4">
      {/* Header Section */}
      <Row className="mb-4">
        <Col>
          <div className="page-title-box d-flex align-items-center justify-content-between mb-0">
            <div className="d-flex align-items-center">
              <div
                onClick={() => navigate(-1)}
                style={{ cursor: 'pointer', fontSize: '24px', fontWeight: '800', display: 'flex', alignItems: 'center', marginRight: '12px' }}
              >
                <IoMdArrowBack className='icon' />
              </div>
              <h4 className="mb-0 fw-bold">{id ? 'Update' : 'Add'} Vendor</h4>
              {store?.isVerified ? (
                <span className="">
                  <Verified style={{ fontSize: '24px', color: 'green', marginLeft: '8px' }} />
                </span>
              ) :
                null
              }
            </div>

            {(user.userType == 'ADMIN' && id && formik.values?.ownerName != '') && (
              <>
                {store?.isVerified ? (
                  null
                ) : (
                  <Button
                    onClick={() => { handleVerifyVendor(); }}
                    disabled={verifyLoading}
                    className={"request_btn"}

                  >
                    {verifyLoading ? (
                      <>

                        Verifying vendor...
                      </>
                    ) : (
                      "Verify Vendor"
                    )}
                  </Button>
                )}
              </>
            )}

          </div>
        </Col>
      </Row>

      {dataLoading ?

        <div className='d-flex justify-content-center align-items-center' style={{ height: '400px' }}>
          <Loader />
        </div>

        : dataError ? (
          <ErrorState
            onRetry={() => {
              setDataError(false)
              getManufacturer()
            }}
          />
        ) : (<Form onSubmit={formik.handleSubmit}>
          {/* Basic Information Card */}
          <Card className="mb-4 shadow-null">

            <Card.Body className="p-4">
              <Row>

                <Row>
                  {/* Left Side - Form Fields (8 columns) */}
                  <Col md={8}>
                    <Row>
                      {/* Store Name - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold">Store Name *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter store name"
                            name="storeName"
                            value={formik.values?.storeName}
                            onChange={handleInputChange}
                            isInvalid={formik.touched.storeName && !!formik.errors.storeName}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.storeName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Owner Name - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold">Owner Name *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter owner name"
                            name="ownerName"
                            value={formik.values?.ownerName}
                            onChange={handleInputChange}
                            isInvalid={formik.touched.ownerName && !!formik.errors.ownerName}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.ownerName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Phone Number - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">Phone Number *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter phone number"
                            name="phoneNumber"
                            value={formik.values?.phoneNumber}
                            onChange={formik.handleChange}
                            isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                            maxLength={10}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.phoneNumber}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Email Address - 6 columns on large screens, 12 on smaller */}
                      <Col md={6} lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">Email Address *</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter email address"
                            name="email"
                            disabled={!!id}
                            value={formik.values?.email}
                            onChange={formik.handleChange}
                            isInvalid={formik.touched.email && !!formik.errors.email}
                            className="rounded-input"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                          Brands associated *
                        </Form.Label>


                        <AsyncSelect
                          isMulti
                          loadOptions={loadOptionsBrands}
                          defaultOptions={brands}
                          classNamePrefix="select"
                          isClearable={true}
                          placeholder="Search and select brands"
                          onChange={onBrandChange}
                          value={selectedBrands}
                          onMenuScrollToBottom={handleMenuScrollToBottom}
                          noOptionsMessage={() => "Type to search brands"}
                          styles={{
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              border: "1px solid #ced4da",
                              borderRadius: "8px",
                              minHeight: "40px",
                              fontSize: "13px",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              display: "flex",
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              overflowY: "hidden",
                              scrollbarWidth: "none",
                              msOverflowStyle: "none",
                              "::-webkit-scrollbar": {
                                display: "none",
                              },
                            }),
                            input: (base) => ({
                              ...base,
                              minWidth: "80px",
                              flexShrink: 0,
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#288d9dff", // purple
                              color: "white",
                              borderRadius: "12px",
                              padding: "0 4px",
                              flexShrink: 0,
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white",
                              fontSize: "12px",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "white",
                              ':hover': {
                                backgroundColor: "#288d9dff",
                                color: "white",
                              },
                            }),
                          }}
                        />

                        <div className="invalid-feedbacks mr-2" style={{ color: "#DC3544", fontSize: "12px" }}>
                          {(brandError || (selectedBrands.length === 0 && formik.submitCount > 0)) && <>

                            At least one brand is required
                          </>}
                        </div>


                      </Form.Group>

                    </Row>
                  </Col>

                  {/* Right Side - Image Upload (4 columns) */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Store Image *</Form.Label>
                      <div
                        className="image-upload-container position-relative rounded p-2 text-center"
                        onClick={() => document.getElementById('storeImage').click()}
                        style={{
                          cursor: 'pointer',
                          height: '230px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '2px dashed #d1d1d1ff', // ✅ Dashed border
                          transition: 'all 0.3s ease',
                          overflow: 'hidden',
                          borderRadius: '16px',
                        }}
                      >
                        {formik.values.img_view ? (
                          <>
                            <img
                              src={formik.values.img_view}
                              alt="Store"
                              className="img-fluid h-150 w-100"
                              style={{
                                objectFit: 'cover'
                              }}
                            />
                            {/* Hover Overlay */}
                            <div
                              className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                              style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                opacity: 0,
                                transition: 'opacity 0.3s ease',
                                color: 'white'
                              }}
                              onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                              onMouseLeave={(e) => (e.currentTarget.style.opacity = '0')}
                            >
                              <FiUploadCloud size={24} className="mb-1" />
                              <small>Change image</small>
                            </div>
                          </>
                        ) : (
                          <>
                            <FiUploadCloud size={28} className="text-muted mb-2" />
                            <p className="text-muted mb-1 small">Click to upload store image</p>

                          </>
                        )}
                      </div>
                      <Form.Control
                        id="storeImage"
                        type="file"
                        onChange={handleImageChange}
                        isInvalid={formik.touched.img_view && formik.errors.img_view}
                        style={{ display: 'none' }}
                        accept="image/*"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.img_view}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                </Row>


                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Description *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter store description"
                      name="description"
                      value={formik.values?.description}
                      onChange={formik.handleChange}
                      className="rounded-input"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Location Information Card */}
          <Card className="mb-4 shadow-sm">
            <Card.Header className="bg-light">
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: '700',
                }}
              >
                Location Information
              </span>
            </Card.Header>
            <Card.Body className="p-4">
              <Row className="mb-4">
                <Col md={12}>
                  <Form.Group className="mb-0">
                    <Form.Label className="fw-semibold">Search Location *</Form.Label>
                    {script && (
                      <GooglePlacesAutocomplete
                        selectProps={{
                          placeholder: 'Type your location...',
                          value,
                          onChange: changeValue,
                          noOptionsMessage: () => 'No locations found',
                          styles: {
                            control: (base) => ({
                              ...base,
                              border: '1px solid #ced4da',
                              borderRadius: '8px',
                              padding: '4px',
                              minHeight: '46px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#6c757d',
                            }),
                          },
                        }}
                      />
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                {/* Left Column - Location Form Fields */}
                <Col md={12} lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Address *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter complete address"
                      name="address"
                      value={formik.values?.address}
                      onChange={handleInputChange}
                      isInvalid={formik.touched.address && !!formik.errors.address}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.address}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">State *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter state"
                          name="state"
                          value={formik.values?.state}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.state && !!formik.errors.state}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.state}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">City *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter city"
                          name="city"
                          value={formik.values?.city}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.city && !!formik.errors.city}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.city}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Pincode *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter pincode"
                          name="postalcode"
                          value={formik.values?.postalcode}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.postalcode && !!formik.errors.postalcode}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.postalcode}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Landmark *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter landmark"
                          name="landmark"
                          value={formik.values?.landmark}
                          onChange={handleInputChange}
                          isInvalid={formik.touched.landmark && !!formik.errors.landmark}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.landmark}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>

                {/* Right Column - Map */}
                <Col md={12} lg={6}>
                  <Form.Label className="fw-semibold">Location Map</Form.Label>
                  <div
                    style={{
                      height: '230px', // Reduced map height
                      width: '100%',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      border: '1px solid #dee2e6',
                    }}
                  >
                    {script && (
                      <GoogleMap
                        bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY }}
                        defaultZoom={15}
                        center={mapCenter}
                        yesIWantToUseGoogleMapApiInternals
                      >
                        <div
                          lat={mapCenter.lat}
                          lng={mapCenter.lng}
                          style={{ color: 'red', fontSize: '32px' }}
                        >
                          <FaMapMarkerAlt className="marker_icon bounce" />
                        </div>
                      </GoogleMap>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>


          {/* Business Details Card */}
          <Card className="mb-4 shadow-sm">
            <Card.Header className="bg-light">
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: '700',
                }}
              >
                Business details
              </span>
            </Card.Header>
            <Card.Body className="p-4">
              <Row>

                <Col md={6}>

                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">Business name on GST Document</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter business name"
                        name="businessName"
                        value={formik.values?.businessName}
                        onChange={handleInputChange}
                        isInvalid={formik.touched.businessName && !!formik.errors.businessName}

                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.businessName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>


                  {/* Gst number */}
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">GST Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter GST number"
                        name="gst"
                        value={formik.values?.gst}
                        onChange={handleInputChange}
                        isInvalid={formik.touched.gst && !!formik.errors.gst}
                        maxLength={15}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.gst}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Pan number */}
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">PAN Number *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter PAN number"
                        name="pan"
                        value={formik.values?.pan}
                        onChange={formik.handleChange}
                        isInvalid={formik.touched.pan && !!formik.errors.pan}
                        maxLength={10}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.pan}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Row md={12}>

                    {/* Commission */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Commission % *</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter commission percentage"
                          name="commission"
                          value={formik.values?.commission}
                          onChange={formik.handleChange}
                          isInvalid={formik.touched.commission && !!formik.errors.commission}
                          min={0}
                          max={100}
                          step="any"
                          readOnly={user?.userType !== 'ADMIN'}
                          className="rounded-input"
                          style={user?.userType !== 'ADMIN' ? { backgroundColor: '#f8f9fa' } : {}}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.commission}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* New GST Applicable Field */}
                    {user?.userType === 'ADMIN' && (<Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">GST Applicable *</Form.Label>
                        <Form.Select
                          name="gstApplicable"
                          value={formik.values?.gstApplicable}
                          onChange={formik.handleChange}
                          isInvalid={formik.touched.gstApplicable && !!formik.errors.gstApplicable}
                          className="rounded-input"
                        >

                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">

                          {formik.errors.gstApplicable}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>)}

                  </Row>



                </Col>



                {/* Right side - Document Uploads */}
                <Col md={6}>
                  <Row>
                    {/* PAN Copy */}
                    <Col md={6} className="mb-2">
                      <Form.Group>
                        <Form.Label className="fw-semibold">PAN Copy</Form.Label>

                        <div
                          className="position-relative rounded d-flex align-items-center justify-content-center"
                          onClick={() => document.getElementById('panCopy').click()}
                          style={{
                            height: '150px',
                            border: '2px dashed #d1d1d1',
                            cursor: 'pointer'
                          }}
                        >
                          {formik.values.pan_copy_view ? (
                            <>
                              <img
                                src={formik.values.pan_copy_view}
                                alt="PAN Copy"
                                className="w-100 h-100 rounded"
                                style={{ objectFit: 'cover' }}
                              />

                              <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                                {/* View */}
                                <div
                                  title="View"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPreview(formik.values.pan_copy_view);
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsEye size={10} className="text-white" />
                                </div>

                                {/* Download */}
                                <div
                                  title="Download"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    downloadImage(formik.values.pan_copy_view, 'PAN_Copy');
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsDownload size={10} className="text-white" />
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="text-center">
                              <FiUploadCloud size={24} className="text-muted mb-2" />
                              <p className="text-muted small mb-0">Click to upload PAN copy</p>
                            </div>
                          )}
                        </div>

                        <Form.Control
                          id="panCopy"
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: 'none' }}
                          accept="image/*"
                        />
                      </Form.Group>
                    </Col>

                    {/* GST Copy */}
                    <Col md={6} className="mb-2">
                      <Form.Group>
                        <Form.Label className="fw-semibold">GST Copy</Form.Label>

                        <div
                          className="position-relative rounded d-flex align-items-center justify-content-center"
                          onClick={() => document.getElementById('gstCopy').click()}
                          style={{
                            height: '150px',
                            border: '2px dashed #d1d1d1',
                            cursor: 'pointer'
                          }}
                        >
                          {formik.values.gst_copy_view ? (
                            <>
                              <img
                                src={formik.values.gst_copy_view}
                                alt="GST Copy"
                                className="w-100 h-100 rounded"
                                style={{ objectFit: 'cover' }}
                              />

                              <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPreview(formik.values.gst_copy_view);
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsEye size={10} className="text-white" />
                                </div>

                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    downloadImage(formik.values.gst_copy_view, 'GST_Copy');
                                  }}
                                  style={{
                                    width: '26px',
                                    height: '26px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <BsDownload size={10} className="text-white" />
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="text-center">
                              <FiUploadCloud size={24} className="text-muted mb-2" />
                              <p className="text-muted small mb-0">Click to upload GST copy</p>
                            </div>
                          )}
                        </div>

                        <Form.Control
                          id="gstCopy"
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: 'none' }}
                          accept="image/*"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Cancelled Cheque */}
                  <Form.Group className="mt-2">
                    <Form.Label className="fw-semibold">Cancelled cheque copy</Form.Label>

                    <div
                      className="position-relative rounded d-flex align-items-center justify-content-center"
                      onClick={() => document.getElementById('cancelledChequeCopy').click()}
                      style={{
                        height: '150px',
                        border: '2px dashed #d1d1d1',
                        cursor: 'pointer'
                      }}
                    >
                      {formik.values.cancelled_cheque_view ? (
                        <>
                          <img
                            src={formik.values.cancelled_cheque_view}
                            alt="Cancelled Cheque"
                            className="w-100 h-100 rounded"
                            style={{ objectFit: 'cover' }}
                          />

                          <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                openPreview(formik.values.cancelled_cheque_view);
                              }}
                              style={{
                                width: '26px',
                                height: '26px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(0,0,0,0.6)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer'
                              }}
                            >
                              <BsEye size={10} className="text-white" />
                            </div>

                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                downloadImage(
                                  formik.values.cancelled_cheque_view,
                                  'Cancelled_Cheque'
                                );
                              }}
                              style={{
                                width: '26px',
                                height: '26px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(0,0,0,0.6)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer'
                              }}
                            >
                              <BsDownload size={10} className="text-white" />
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="text-center">
                          <FiUploadCloud size={24} className="text-muted mb-2" />
                          <p className="text-muted small mb-0">
                            Click to upload Cancelled Cheque copy
                          </p>
                        </div>
                      )}
                    </div>

                    <Form.Control
                      id="cancelledChequeCopy"
                      type="file"
                      onChange={handleImageChange}
                      style={{ display: 'none' }}
                      accept="image/*"
                    />
                  </Form.Group>
                </Col>




              </Row>
            </Card.Body>
          </Card>

          {/* Bank Details Card */}
          <Card className="mb-4 shadow-sm">
            <Card.Header className="bg-light">
              <span style={{

                fontSize: '16px',
                fontWeight: '700',


              }}>
                Bank details
              </span>
            </Card.Header>
            <Card.Body className="p-4">
              <Row>
                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Bank Name *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter bank name"
                      name="bankName"
                      value={formik.values?.bankName}
                      onChange={handleInputChange}
                      isInvalid={formik.touched.bankName && !!formik.errors.bankName}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.bankName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Account Type *</Form.Label>
                    <Form.Select
                      name="accountType"
                      value={formik.values.accountType}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.accountType && !!formik.errors.accountType}
                      className="rounded-input"
                    >
                      <option value="">Select account type</option>
                      <option value="Savings">Savings</option>
                      <option value="Current">Current</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.accountType}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Account Holder Name *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter account holder name"
                      name="accountHolderName"
                      value={formik.values?.accountHolderName}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.accountHolderName && !!formik.errors.accountHolderName}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.accountHolderName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Account Number *</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        placeholder="Enter account number"
                        name="accountNumber"
                        value={formik.values?.accountNumber}
                        onChange={formik.handleChange}
                        isInvalid={formik.touched.accountNumber && !!formik.errors.accountNumber}
                        className="rounded-input"
                      />
                      {/* <span
                      className="position-absolute top-50 end-0 translate-middle-y me-3"
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleaccountNumberVisibility("accountNumber")}
                    >
                      {showaccnumber.accountNumber ? <BsEye /> : <BsEyeSlash />}
                    </span> */}
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.accountNumber}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Re-enter Account Number *</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type={showaccnumber.reaccountNumber ? "text" : "password"}
                        placeholder="Re-enter account number"
                        name="reaccountNumber"
                        value={formik.values?.reaccountNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={formik.touched.reaccountNumber && !!formik.errors.reaccountNumber}
                        className="rounded-input pe-5"
                      />
                      <span
                        className="position-absolute top-50 end-0 translate-middle-y me-3"
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleaccountNumberVisibility("reaccountNumber")}
                      >
                        {showaccnumber.reaccountNumber ? <BsEye /> : <BsEyeSlash />}
                      </span>
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.reaccountNumber}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">IFSC Code *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter IFSC code"
                      name="ifscCode"
                      value={formik.values?.ifscCode}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.ifscCode && !!formik.errors.ifscCode}
                      maxLength={11}
                      className="rounded-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.ifscCode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>


          {/* Store Timings Card - Table Layout */}
          <Card className="mb-4">
            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
              <span style={{ fontSize: '16px', fontWeight: '700' }}>
                Store Timings
              </span>

              <Button
                onClick={() => {
                  const mondayTiming = formik.values.storeTimings.find(t => t.day === "Monday");
                  if (mondayTiming) {
                    const updatedTimings = formik.values.storeTimings.map(timing =>
                      timing.day !== "Monday"
                        ? {
                          ...timing,
                          openingTime: mondayTiming.openingTime,
                          closingTime: mondayTiming.closingTime,
                        }
                        : timing
                    );
                    formik.setFieldValue("storeTimings", updatedTimings);
                  }
                }}
                variant="outline-dark"
                className="subcategory-add-button fs-8"
              >
                Apply Monday timing to all
              </Button>

            </Card.Header>

            <Card.Body className="p-4">
              <Row>
                <Col md={12}>
                  <div className="table-responsive bg-light rounded">
                    <table className="table mb-0">
                      <thead>
                        <tr>
                          <th className="fw-semibold text-center py-3">Day</th>
                          <th className="fw-semibold text-center py-3">Status</th>
                          <th className="fw-semibold text-center py-3">Opening Time</th>
                          <th className="fw-semibold text-center py-3">Closing Time</th>
                          <th className="fw-semibold text-center py-3">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formik.values.storeTimings.map((timing, index) => (
                          <tr key={index} className="border-bottom">
                            <td className="fw-medium text-center align-middle">{timing.day}</td>
                            <td className="text-center align-middle">
                              {timing?.isActive ? (
                                <span className="badge bg-success" style={{ fontSize: '0.8rem', padding: '0.5em 1em' }}>Open</span>
                              ) : (
                                <span className="badge bg-danger" style={{ fontSize: '0.8rem', padding: '0.5em 1em' }}>Closed</span>
                              )}
                            </td>
                            <td className="text-center align-middle">
                              <Form.Control
                                type="time"
                                name={`storeTimings.${index}.openingTime`}
                                value={formik.values.storeTimings[index].openingTime}
                                onChange={formik.handleChange}
                                className="rounded-input form-control-sm mx-auto"
                                disabled={!timing?.isActive}
                                style={{ minWidth: '100px', maxWidth: '120px' }}
                              />
                            </td>
                            <td className="text-center align-middle">
                              <Form.Control
                                type="time"
                                name={`storeTimings.${index}.closingTime`}
                                value={formik.values.storeTimings[index].closingTime}
                                onChange={formik.handleChange}
                                className="rounded-input form-control-sm mx-auto"
                                disabled={!timing?.isActive}
                                style={{ minWidth: '100px', maxWidth: '120px' }}
                              />
                            </td>
                            <td className="text-center align-middle">
                              <div className="d-flex justify-content-center">
                                <Switch
                                  size="20px"
                                  id={`custom-switch-${index}`}
                                  checked={timing?.isActive}
                                  onChange={(e) => statusActive(timing?.id, timing?.isActive, index)}
                                  className="custom-switch"
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>




          {/* Action Buttons */}
          <div className="d-flex justify-content-end gap-3 mt-4 p-3 bg-white" style={{ zIndex: 1000 }}>
            <Button
              variant="outline-secondary"
              onClick={() => cancelStore()}
              className="cancel_btn"
              style={{ minWidth: '120px' }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="request_btn"
              style={{ minWidth: '120px' }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Processing...
                </>
              ) : id ? (
                'Update Vendor Details'
              ) : (
                'Create New Vendor'
              )}
            </Button>
          </div>
        </Form>)}



      <Modal
        show={showPreview}
        onHide={closePreview}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              style={{
                width: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '12px',
              }}
            />
          )}
        </Modal.Body>
      </Modal>


      <style jsx>{`
        
        .rounded-input {
          border-radius: 16px;
        }
        .image-upload-container {
          transition: all 0.3s ease;
          border: 2px dashed #dee2e6;
        }
        .image-upload-container:hover {
          border-color: #0d6efd;
          background-color: #f8f9fa;
        }
        .marker_icon {
          animation: bounce 1s infinite;
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .store-timings-display {
          max-height: 300px;
          overflow-y: auto;
        }
        .store-timings-edit .accordion-button:not(.collapsed) {
          background-color: #f8f9fa;
          color: #000;
        }
      `}</style>
    </Container>

  )


}

export default CreateManufacturer
